import { mapKeys } from 'lodash-es'

export const IS_FLAT_MENU = 'IsFlatMenu'
export const IS_HORIZONTAL_MENU = 'IsHorizontalMenu'
export const IS_DUPLICATE_DESCRIPTOR = 'IsDuplicateDescriptor'
export const IS_DUPLICATE_DISH = 'IsDuplicateDish'
export const IS_OVERLAPPING_SELECTOR = 'IsOverlappingSelector'
export const IS_RETRY_POLICY_USED = 'IsRetryPolicyUsed'
export const IS_INVALID_SELECTOR = 'IsInvalidSelector'

export const SCRAPING_FLAGS = mapKeys(
  [
    { name: 'Flat menu detected', value: IS_FLAT_MENU },
    { name: 'Horizontal menu', value: IS_HORIZONTAL_MENU },
    { name: 'Duplicate descriptor', value: IS_DUPLICATE_DESCRIPTOR },
    { name: 'Duplicate dish', value: IS_DUPLICATE_DISH },
    { name: 'Is overlapping selector', value: IS_OVERLAPPING_SELECTOR },
    { name: 'Is retry policy used', value: IS_RETRY_POLICY_USED },
    { name: 'Is invalid selector', value: IS_INVALID_SELECTOR },
  ],
  'value',
)
